import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { useViewerCount } from '../state/viewerCountState';
import { formatDuration } from '../utils/time';
import { EyeIcon } from './Icon';
import { Badge as PrestyledBadge } from './Ui';
export function LiveIndicator({ streamId, startedAt }) {
    const [durationInSeconds, setDurationInSeconds] = useState(0);
    const viewerCount = useViewerCount(streamId);
    useEffect(function trackDuration() {
        setDurationInSeconds(0);
        const intervalId = window.setInterval(() => {
            if (startedAt == null) {
                return;
            }
            setDurationInSeconds(Math.floor((Date.now() - new Date(startedAt).getTime()) / 1000));
        }, 1000);
        return () => {
            window.clearInterval(intervalId);
        };
    }, [startedAt]);
    if (startedAt == null) {
        return null;
    }
    return (_jsxs(LiveIndicatorRoot, { children: [_jsxs(Badge, { children: [_jsx(RecordingDot, {}), _jsx("strong", { children: "Live" }), " \u00B7", ' ', _jsx("div", { children: formatDuration(durationInSeconds) })] }), _jsxs(ViewerCountBadge, { children: [_jsx(EyeIcon, {}), viewerCount] })] }));
}
const blink = keyframes `
    0%, 49% {
      opacity: 1;
    }

    50%, 100% {
      opacity: 0.2;
    }
`;
const RecordingDot = styled.div `
    background: #ff4015;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    animation: ${blink} 2s infinite ease-in-out;
`;
const Badge = styled(PrestyledBadge) `
    align-items: center;
    display: flex;
    gap: 0.25rem;
    height: 2rem;
    padding-top: 0;
    padding-bottom: 0;
    letter-spacing: -0.02em;
`;
const ViewerCountBadge = styled(Badge) `
    font-size: 0.875rem;
`;
const LiveIndicatorRoot = styled.div `
    align-items: center;
    gap: 0.5rem;
    display: none;

    strong {
        font-weight: 600;
        display: block;
    }

    @media (min-width: 20rem) {
        display: flex;
    }
`;
